import React from "react";
import { Input } from "./Number.styled";

const NumberInput = ({ ...otherProps }) => <Input min={0} type="number" {...otherProps} />;

export default NumberInput;
